import { Radio as RadioPrimitive } from '@base-ui/react/radio';
import { RadioGroup as RadioGroupPrimitive } from '@base-ui/react/radio-group';

import { cn } from '@ui/lib/utils';

const radioItemLayout = 'group/radio-group-item peer relative flex aspect-square size-4 shrink-0 rounded-full';
const radioItemBorder = 'border border-input outline-none after:absolute after:-inset-x-3 after:-inset-y-2';
const radioItemFocus = 'focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50';
const radioItemDisabled = 'disabled:cursor-not-allowed disabled:opacity-50';
const radioItemInvalid = cn(
  'aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20',
  'aria-invalid:aria-checked:border-primary'
);
const radioItemDark = 'dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40';
const radioItemChecked = cn(
  'data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground',
  'dark:data-checked:bg-primary'
);

const radioIndicatorPosition = 'absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2';

const RadioGroup = ({ className, ...props }: RadioGroupPrimitive.Props) => {
  return <RadioGroupPrimitive data-slot="radio-group" className={cn('grid w-full gap-2', className)} {...props} />;
};

const RadioGroupItem = ({ className, ...props }: RadioPrimitive.Root.Props) => {
  return (
    <RadioPrimitive.Root
      data-slot="radio-group-item"
      className={cn(
        radioItemLayout,
        radioItemBorder,
        radioItemFocus,
        radioItemDisabled,
        radioItemInvalid,
        radioItemDark,
        radioItemChecked,
        className
      )}
      {...props}
    >
      <RadioPrimitive.Indicator data-slot="radio-group-indicator" className="flex size-4 items-center justify-center">
        <span className={cn(radioIndicatorPosition, 'rounded-full bg-primary-foreground')} />
      </RadioPrimitive.Indicator>
    </RadioPrimitive.Root>
  );
};

export { RadioGroup, RadioGroupItem };
